<app-table
  [lazy]="true"
  [cols]="columns"
  tableTitle="Transações Com Status Criado"
  [addButton]="false"
  [exportPdf]="false"
  [exportExcel]="false"
  [refreshButton]="false"
  [service]="bfluenceIntegrityService"
  pageFunctionName="getCreatedTransactionBenefitTable"
  emptyMessage="Sem mais registros com status criado no momento."
  selectionActionLabel="Corrigir"
  selectionActionTooltip="Marcar como resolvido"
  selectionActionIcon="pi pi-check"
  (emitSelection)="markAsResolved($event)"
  modelName="registros"
  [defaultRows]="10"
></app-table>
<p-confirmDialog></p-confirmDialog>
<p-toast></p-toast>
